import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=4aa86e4c&scoped=true&lang=pug&"
import script from "./ReadMore.vue?vue&type=script&lang=ts&"
export * from "./ReadMore.vue?vue&type=script&lang=ts&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=4aa86e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa86e4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa86e4c')) {
      api.createRecord('4aa86e4c', component.options)
    } else {
      api.reload('4aa86e4c', component.options)
    }
    module.hot.accept("./ReadMore.vue?vue&type=template&id=4aa86e4c&scoped=true&lang=pug&", function () {
      api.rerender('4aa86e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ReadMore.vue"
export default component.exports